import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { DASHBOARD } from 'constants/controllers'
import { GARedirect } from 'helpers/redirects'
import DashboardAolWrapper from './DashboardAolWrapper'
import Header from './Header'

export default new Controller({
  name: DASHBOARD,
  route: 'news(/:aol)',
  controller (Router, { params: { aol }, queryString, query, url }, render) {
    if (GARedirect(queryString)) {
      return
    }

    const pageId = getUrl(DASHBOARD, { aol })
    render(
      { Main: DashboardAolWrapper, Header },
      { aol, query },
      {
        searchType: 'qa',
        pageId,
        className: 'dashboard',
        name: DASHBOARD,
        aol
      }
    )
    return pageId
  }
})
